import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StorageService } from '../services/storage.service';
import { UserService } from '../services/user.service';
import { User } from '../entities/user';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable, from } from 'rxjs';
const TOKEN_KEY = environment.tokenName;

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  token: string;
  user: User;
  env = environment;

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private userService: UserService,
  ) {
    this.loadToken();
  }

  async loadToken() {
    // Check if already authenticated through the mobile app login
    if (this.storageService.token && this.storageService.token !== "") {
      this.token = this.storageService.token;
      this.isAuthenticated.next(true);
      return;
    }
    else {
      this.storageService.get(TOKEN_KEY).then(result => {
        this.token = result;
        if (this.storageService.token && this.storageService.token !== "") {
          this.storageService.token = result;
        }
        console.log("token is: " + this.token);
        if (this.token && this.token.length > 0) {
          this.isAuthenticated.next(true);
          return;
        }
      });
    }
    // Check if already authenticated through the web version login
    if (this.userService.user && this.userService.user.Email !== "") {
      this.user = this.userService.user;
      this.isAuthenticated.next(true);
      return;
    }
    else {
      this.storageService.get("user").then(result => {
        this.user = result;
        if (this.userService.user && this.userService.user.Email !== "") {
          this.userService.user = result;
        }
        console.log("user is: " + this.user?.Email);
        if (this.user && this.user.Email.length > 0) {
          this.isAuthenticated.next(true);
          return;
        }
      });
    }

    //Check if already authenticated when routed directly from ACP or direct link
    this.userService.getUser().subscribe(user => {
      if (user?.Email?.length > 0) {
        console.log("user is: " + user?.Email);
        this.user = user;
        this.isAuthenticated.next(true);
      } else {
        this.user = null;
        this.storageService.get('isRoutedFromACP').then(result => {
          if (result === true) {
            this.storageService.removeAll();
            window.close();
          }
          else {
            // Navigate to login page if not routed from ACP
            this.isAuthenticated.next(false);
          }
        });
      }
    });
  }

  login(credentials: { Email, Password }): Observable<any> {
    return this.http.post(`${environment.baseApiUrl}login`, credentials, { withCredentials: true });
  }

  logout(): Promise<any> {
    this.isAuthenticated.next(false);
    return this.storageService.removeAll();
  }
}
